<template>
    <div class="charts">
        <div class="charts-row">
            <div class="charts-item item0">
                <div class="charts_item_title">
                    <img src="../assets/Chart1.png"/>
                    本月数据统计
                </div>
                <div class="select">
                    <el-date-picker v-model="month" type="month" placeholder="选择月" format="yyyy 年 MM 月" value-format="yyyy-MM" @change="drawPie"></el-date-picker>
                </div>
                <div class="charts-item-content">
                    <div class="chart">
                        <div class="pie_center">￥{{ordermoney}}</div>
                        <div id="chartTwo" style="width:100%;height:4.4rem;"></div>
                    </div>
                </div>
            </div>
            <div class="charts_sum" style="width:15%;">
                <div class="charts_sum_one">
                    <div class="sum">本月收入</div>
                    <div class="money">￥{{ordermoney}}</div>
                    <div class="sum">支付宝收入</div>
                    <div class="money">￥{{alipayMoney}}</div>
                    <div class="sum">微信收入</div>
                    <div class="money">￥{{weixinpayMoney}}</div>
                    <div class="sum">银行卡收入</div>
                    <div class="money">￥{{mspayMoney}}</div>
                    <div class="sum">线下收入</div>
                    <div class="money">￥{{offpayMoney}}</div>
                </div>
            </div>
            <div class="charts-item item0">
                <div class="charts_item_title">
                    <img src="../assets/Chart2.png"/>
                    2018年数据统计
                </div>
                <div class="select">
                    <el-date-picker v-model="year" type="year" placeholder="选择年" format="yyyy 年" value-format="yyyy" @change="drawLine"></el-date-picker>
                </div>
                <div class="charts-item-content2">
                    <div class="chart" >
                        <div id="chartOne"  ref="echarts" style="width:90%;height:5rem;"></div>
                    </div>
                </div>
            </div>
            <div class="charts_sum" style="width:15%;">
                <div class="charts_sum_one">
                    <div class="sum">年收入</div>
                    <div class="money">￥{{ordermoneynum}}</div>
                    <div class="sum">一季度收入</div>
                    <div class="money">￥{{array1}}</div>
                    <div class="sum">二季度收入</div>
                    <div class="money">￥{{array2}}</div>
                    <div class="sum">三季度收入</div>
                    <div class="money">￥{{array3}}</div>
                    <div class="sum">四季度收入</div>
                    <div class="money">￥{{array4}}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import store from "../store";
    import Vue from 'vue'

    let echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/title');
    require('echarts/lib/chart/pie');
    require('echarts/lib/component/legend');

    export default {
        name: "Echarts",
        components: {},
        data() {
            return {
                tabPosition: 'top',

                uid: '',
                token: '',
                ordermoney: 0,
                alipayMoney: 0,
                weixinpayMoney: 0,
                mspayMoney: 0,
                offpayMoney: 0,
                ordermoneynum: 0,
                array1: 0,
                array2: 0,
                array3: 0,
                array4: 0,
                current_time: "",
                month: "",
                year: "",
            }
        },
        mounted() {
            this.current_time = store.getters.getNowFormatDateVal;
            this.month = this.current_time.substring(0, 7);
            this.year = this.current_time.substring(0, 4);

            this.drawLine();
            this.drawPie();
        },
        methods: {
            drawLine() {
                var begin_month = this.year + "-01";
                var end_month = this.year + "-12";

                this.$http.get(`${store.state.url}finance/financeAggregation/`+ begin_month + `/` + end_month + `/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        var datemonth = this.year;
                        var myArray = new Array();
                        var myArray_toFixed = new Array();
                        var ordermoneynum = 0;
                        for (var j = 0; j < 12; j++) {
                            var month = "01";
                            var ordermoney = 0;
                            if ((j + 1) < 10) {
                                month = "0" + (j + 1);
                            } else {
                                month = (j + 1);
                            }
                            for (var i in res.Data) {
                                if (res.Data[i].month == (datemonth + "-" + month)) {
                                    ordermoney = (res.Data[i].ordermoney + res.Data[i].xordermoney);
                                }
                            }
                            ordermoneynum += ordermoney;
                            myArray.push(ordermoney);
                            myArray_toFixed.push(ordermoney.toFixed(2));
                        }
                        this.ordermoneynum = ordermoneynum.toFixed(2);
                        this.array1 = (myArray[0] + myArray[1] + myArray[2]).toFixed(2);
                        this.array2 = (myArray[3] + myArray[4] + myArray[5]).toFixed(2);
                        this.array3 = (myArray[6] + myArray[7] + myArray[8]).toFixed(2);
                        this.array4 = (myArray[9] + myArray[10] + myArray[11]).toFixed(2);

                        //柱状图
                        let myChart = echarts.init(document.getElementById('chartOne'));
                        window.addEventListener("resize", function(){
                            myChart.resize();
                        });
                        // var yMax = 500;
                        // var dataShadow = [];
                        // for (var i = 0; i < myArray_toFixed.length; i++) {
                        //     dataShadow.push(yMax);
                        // }

                        myChart.setOption({
                            // title: {
                            //     text: '2018年数据统计'
                            // },
                            tooltip: {},
                            grid: {
                                left: 340,
                                bottom: 65,
                            },
                            xAxis: {
                                data: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
                            },
                            yAxis: {
                                type: 'value',
                            },
                            series: [
                                {
                                    name: '收入',
                                    type: 'bar',
                                    itemStyle: {
                                        normal: {
                                            color: new echarts.graphic.LinearGradient(
                                                0, 0, 0, 1,
                                                [
                                                    {offset: 0, color: '#108ee9'},
                                                    {offset: 1, color: '#C2DBFF'}
                                                ]
                                            )
                                        }
                                    },
                                    data: myArray_toFixed,
                                    barWidth: '50%',
                                    markPoint: {
                                        data: [
                                            {type: 'max', name: '最大值'},
                                            {type: 'min', name: '最小值'}
                                        ]
                                    }
                                }
                            ]
                        });
                    })
            },
            drawPie() {
                this.$http.get(`${store.state.url}finance/financeAggregation/${this.month}/${this.month}/${window.localStorage.userid}?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                    .then((res) => {
                        var ordermoney = 0;
                        var alipayMoney = 0;
                        var weixinpayMoney = 0;
                        var mspayMoney = 0;
                        var offpayMoney = 0;
                        for (let i in res.Data) {
                            ordermoney = res.Data[i].ordermoney + res.Data[i].xordermoney;
                            alipayMoney = res.Data[i].zordermoney;
                            weixinpayMoney = res.Data[i].wordermoney;
                            mspayMoney = res.Data[i].mordermoney;
                            offpayMoney = res.Data[i].xordermoney;
                        }
                        this.ordermoney = ordermoney.toFixed(2);
                        this.alipayMoney = alipayMoney.toFixed(2);
                        this.weixinpayMoney = weixinpayMoney.toFixed(2);
                        this.mspayMoney = mspayMoney.toFixed(2);
                        this.offpayMoney = offpayMoney.toFixed(2);

                        //环形图
                        var chart = echarts.init(document.getElementById('chartTwo'));
                        window.addEventListener("resize", function(){
                            chart.resize();
                        });
                        chart.setOption({
                            tooltip: {
                                trigger: 'item',
                                formatter: "{a} <br/>{b} : {c} ({d}%)"
                            },
                            grid: {
                                left: 28,
                                bottom: 65,
                            },
                            legend: {
                                orient: 'horizontal',
                                y: 'bottom',
                                x: 'center',
                                data: ['支付宝', '微信', '银行卡', '线下'],
                            },
                            graphic:{
                                type:'text',
                                left:'center',
                                top:'center',
                                style:{
                                    text:'Part1\n   财务规划，绩效和控制\n  Financial Reporting ,\nPlanning,Performance\n and Control',
                                    textAlign:'center',
                                    fill:'#000',
                                    width:30,
                                    height:30
                                }
                            },
                            series: [
                                {
                                    name: '收入情况',
                                    type: 'pie',
                                    radius: ['50%', '70%'],
                                    avoidLabelOverlap: false,
                                    label: {
                                        normal: {
                                            show: false,
                                            position: 'top',
                                        },
                                        // emphasis: {
                                        //     show: true,
                                        //     textStyle: {
                                        //         fontSize: '30',
                                        //         fontWeight: 'bold'
                                        //     }
                                        // }
                                    },
                                    labelLine: {
                                        normal: {
                                            show: false
                                        }
                                    },
                                    data: [
                                        {value: alipayMoney, name: '支付宝'},
                                        {value: weixinpayMoney, name: '微信'},
                                        {value: mspayMoney, name: '银行卡'},
                                        {value: offpayMoney, name: '线下'}
                                    ]
                                }
                            ]
                        });
                    })
            },
        },
    }
</script>

<style scoped>
    .charts div {
        overflow: auto;
    }
    .charts .charts-row {
        display: flex;
        flex-direction: row;
        justify-content: left;
        padding: 0.2rem 0;
    }
    .pie_center {
        display: flex;
        justify-content: center;
        font-size: 0.26rem;
        font-weight: bold;
        transform: translateY(2.5rem);
    }

    .charts .charts-row .item0 {
        width: 35%;
        background: #fff;
    }

    .charts_item_title {
        position: absolute;
        font-size: 0.3rem;
        padding-left: 0.4rem;
        display: flex;
        justify-content: left;
    }

    .charts_item_title img {
        width: 0.45rem;
        height: 0.45rem;
        margin-right: 0.1rem;
    }

    .select {
        margin-left: 85%;
    }

    .charts .charts-row .charts-item-content {
        padding: 0.1rem;
        padding-top: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 60%;
    }
    .charts .charts-row .charts-item-content2 {
        padding: 0.4rem;
        padding-top: 0;
        display: flex;
        justify-content: center;
        flex-direction: column;
        height: 60%;
    }

    .charts div {
        overflow: visible;
    }

    .charts_sum_one {
        width: 1.2rem;
        padding-top: 1rem;
    }

    .sum {
        font-size: 0.22rem;
        color: #565656;
        height: 0.4rem;
        border-bottom: 1px solid #108ee9;
    }

    .money {
        font-size: 0.22rem;
        color: red;
        height: 0.4rem;
    }
    .charts_item_title img {
        width: 0.35rem;
        height: 0.35rem;
    }
    .charts_item_title {
        font-size: 0.25rem;
    }
    #chartOne {
        height: 350px;
        width: 50px;
    }
    .charts_sum {
        height: 350px;
    }
    .charts_sum_one {
        height: 50%;
    }
    .charts_sum_one>div {
        height: 50%;
    }
    .charts-item .item0 {
        height: 100%;
    }
</style>
